import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, take } from 'rxjs';
import { Authentication, AuthService } from '../services/auth.service';
import { toastrConfig, TOKEN_HEADER_KEY } from '../../app.config';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { jwtDecode } from 'jwt-decode';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService,
              private router: Router,
              private translateService: TranslateService,
              private toastr: ToastrService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | UrlTree | boolean {
    return this.authService.authentication$.pipe(
      take(1),
      map((auth: Authentication | null) => {
        if (auth === null) {
          this.router.navigate(['/login']);
          return false;
        }

        const token = localStorage.getItem(TOKEN_HEADER_KEY);
        if (!token) {
          this.toastr.info(this.translateService.instant("LOGIN.EXPIRED_TOKEN"), "", toastrConfig);
          this.router.navigate(['/login']);
          return false;
        }

        return true;
      })
    );
  }
}
